// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentString: 'Acceptance',
  apiUrl: 'https://crossover.accp.ntsapps.nl/api/',
  cognito: {
    userPoolId: 'eu-central-1_RtS9QZbAr',
    userPoolClientId: '79l0ooreml4m2d8qlki703lqdm'
  },
  clientId: '79l0ooreml4m2d8qlki703lqdm',
  responseType: 'code',
  scope: 'openid+profile',
  redirectUri: 'https://crossover.accp.ntsapps.nl/api/auth',
  logoutUri: 'https://crossover.accp.ntsapps.nl/api/logout',
  loginUrl: '',
  logoutUrl: ''
};

environment.loginUrl = `https://auth.crossover.ntsapps.nl/login/continue?client_id=${environment.clientId}&response_type=${environment.responseType}&scope=${environment.scope}&redirect_uri=${environment.redirectUri}`;
environment.logoutUrl = `https://auth.crossover.ntsapps.nl/logout?client_id=${environment.clientId}&response_type=${environment.responseType}&scope=${environment.scope}&redirect_uri=${environment.logoutUri}`;
